import React from "react";

//import stock
import img from "../img/stock1.png";
import img1 from "../img/map.png";
import img3 from "../img/stock2.png";
import img5 from "../img/kickstarter.gif";

class Portfolio extends React.Component {
  render() {
    return (
      <section id="work" className="portfolio-mf sect-pt4 route">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="title-box text-center">
                <h3 className="title-a">Portfolio</h3>
                <p className="subtitle-a">View some of my work.</p>
                <div className="line-mf"></div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="work-box">
                <a href={img} data-lightbox="gallery-vmarine">
                  <div className="work-img">
                    <img src={img} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-8">
                        <h2 className="w-title">
                          Reddit Financial Sentiment Analysis App
                        </h2>
                        <div className="w-more">
                          <span className="w-ctegory">
                            Python Plotly Streamlit DropboxAPI Heroku
                          </span>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href={img3}
                  data-lightbox="gallery-vmarine"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <a href={img1} data-lightbox="gallery-aguadeluz">
                  <div className="work-img">
                    <img
                      src={img1}
                      alt=""
                      className="img-fluid"
                      style={{ paddingTop: "50px", paddingBottom: "40px" }}
                    />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-8">
                        <h2 className="w-title">Twitter Disaster Detection</h2>
                        <div className="w-more">
                          <span className="w-ctegory">
                            Python Tensorflow GoogleAPI
                          </span>{" "}
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div className="col-md-4">
              <div className="work-box">
                <a href={img5} data-lightbox="gallery-smth">
                  <div className="work-img">
                    <img
                      src={img5}
                      alt=""
                      className="img-fluid"
                      style={{ paddingTop: "100px", paddingBottom: "82px" }}
                    />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-8">
                        <h2 className="w-title">Kickstarter App (Ethereum) </h2>
                        <div className="w-more">
                          <span className="w-ctegory">
                            ReactJS Solidity MaterialUI{" "}
                          </span>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Portfolio;
